import React, { Component } from "react";
import "./../../../assests/styles/CreditLines.css";
import JtMultiSelect from "./../../../common/utils/JtMultiSelect.js";
import "./../../../assests/styles/CreditLines.css";
import CreditTransactionApiHandler from "./../CreditTransactionApiHandler.js";
import Popper from "@material-ui/core/Popper";
import Button from "@material-ui/core/Button";
import "react-datepicker/dist/react-datepicker.css";
import "./../../../assests/styles/newstyle.css";


export class CreditTransactionsHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			statuses: [],
			productName: [],
			BZID: null,
			selectedStatuses: [],
			selectedProduct: null,
			fromDateCreated: null,
			toDateCreated: null,
			selectedCreditPortal: null,
			dueDateFrom: null,
			dueDateTo: null,
			creditPortals: [],
			anchorEl: null
		};
		this.setStatuses = this.setStatuses.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSearchLocal = this.handleSearchLocal.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleDownloadDump = this.handleDownloadDump.bind(this);
		this.setBzId = this.setBzId.bind(this);
		this.applyMultiSelected = this.applyMultiSelected.bind(this);
		this.setFromDate = this.setFromDate.bind(this);
		this.setToDate = this.setToDate.bind(this);
		this.hitApiOnEnter = this.hitApiOnEnter.bind(this);
		this.selectFromDate = this.selectFromDate.bind(this);
		this.selectToDate = this.selectToDate.bind(this);
		this.productTypePicker = this.productTypePicker.bind(this);
		this.clearBzId = this.clearBzId.bind(this);
	}

	componentDidMount() {
		this.fetchConfig();
		this.hitApiOnEnter();
		if(this.props.bzIdFromDexter) {
			this.setState({
				BZID: this.props.bzIdFromDexter
			})
		}
		var searchedBzid = JSON.parse(localStorage.getItem("searched_bzid"));
		if(searchedBzid){
			this.setState({
				BZID: searchedBzid
			})
		}
		if(this.props.productNameFromDexter) {
			this.setState({
				selectedCreditPortal: this.props.productNameFromDexter
			})
		}
	}

	handleSearchLocal() {
		this.props.handleSearch(this.state.BZID, this.state.selectedStatuses, this.state.fromDateCreated, this.state.toDateCreated, this.state.selectedCreditPortal, this.state.dueDateFrom, this.state.dueDateTo, 0);
	}

	handleDownloadDump() {
		this.props.handleDumdDownload(this.state.BZID, this.state.selectedStatuses, this.state.fromDateCreated, this.state.toDateCreated, this.state.selectedCreditPortal, this.state.dueDateFrom, this.state.dueDateTo);
	}

	handleClick = event => {
		const { currentTarget } = event;
		this.setState(state => ({
			anchorEl: state.anchorEl ? null : currentTarget
		}));
	};

	getProductName() {
		var options;
		if (this.state.creditPortals) {
			options = this.state.creditPortals.map((st, index) => {
				return <option key={index}>{st}</option>;
			});
		}
		return options;
	}

	clearBzId() {
		var emptyString = "";
		this.setState({
			BZID: emptyString
		})
	}

	productTypePicker(event) {
		this.setState({
			selectedCreditPortal: event.target.value
		});
	}

	selectFromDate(event) {
		this.setState({
			dueDateFrom: event.target.value
		});
	}

	selectToDate(event) {
		this.setState({
			dueDateTo: event.target.value
		});
	}

	handleClear() {
		// debugger;
		var emptyString = "";
		this.setState({
			BZID: emptyString,
			selectedStatuses: [],
			fromDateCreated: emptyString,
			toDateCreated: emptyString,
			selectedCreditPortal: emptyString,
			dueDateFrom: emptyString,
			dueDateTo: emptyString
		});
	}

	hitApiOnEnter() {
		var input = document.getElementById("myInput");
		input.addEventListener("keyup", function (event) {
			event.preventDefault();
			if (event.keyCode === 13) {
				document.getElementById("myBtn").click();
			}
		});
	}

	setStatuses(status) {
		var result = [];
		for (var i in status) {
			var obj = {};
			obj.key = status[i];
			result.push(obj);
		}
		this.setState({ statuses: result });
	}

	fetchConfig() {
		CreditTransactionApiHandler.getCreditTransactionConfig()
			.then(
				function (resp) {
					this.setStatuses(resp.creditPaymentInstrumentStatusSet);
					this.setState({
						creditPortals: resp.creditProducts
					});
				}.bind(this)
			)
			.catch(function (error) {
				console.log(error);
			});
	}

	handleChange(date) {
		this.setState({
			startDate: date
		});
	}
	render() {
		// debugger;
		return <div id="myInput">{this.makeTopActionbar()}</div>;
	}
	setBzId(e) {
		this.setState({
			BZID: e.target.value
		});
		localStorage.setItem("searched_bzid",JSON.stringify(e.target.value));
	}
	applyMultiSelected(status) {
		var keyValueOfStatus = [];
		console.log("inside apply multiSelect, selected:",status)
		keyValueOfStatus = status.map((st, index) => {
			return st.key;
		});
		this.setState({
			selectedStatuses: keyValueOfStatus
		});
		return keyValueOfStatus;
	}
	setFromDate(e) {
		this.setState({
			fromDateCreated: e.target.value
		});
	}
	setToDate(e) {
		this.setState({
			toDateCreated: e.target.value
		});
	}
	showMore() {
		const { anchorEl } = this.state;
		const open = Boolean(anchorEl);
		const id = open ? "no-transition-popper" : null;
		return (
			<div>
				<Button aria-describedby={id} onClick={this.handleClick} style={{ padding: "0px" }}>
					More
				</Button>
				<Popper id={id} open={open} anchorEl={anchorEl} className="modalstyle">
					<div className="extraFilters">
						{this.makeLabels()}
						<div className="row rowStylePopper">
							<div className="col-md-4 productname top-filter nopadding">
								<select id="ProductName" className="selectpicker productname" onChange={this.productTypePicker} value={this.state.selectedCreditPortal}>
									<option> Select Product Name </option>
									{this.getProductName()}
								</select>
							</div>
							<div className="col-md-4 top-filter nopadding">
								<input type="date" id="date" className="textbox-n filter-text form-control smallText" onChange={this.selectFromDate} value={this.state.dueDateFrom} />
							</div>
							<div className="col-md-4 top-filter nopadding">
								<input type="date" id="date" className="textbox-n filter-text form-control smallText" onChange={this.selectToDate} value={this.state.dueDateTo} />
							</div>
						</div>
					</div>
				</Popper>
			</div>
		);
	}

	makeLabels() {
		return (
			<div className="" style={{ padding: "0px 0px 0px 30px" }}>
				<div className="row">
					<div className="row TopLables" style={{ fontSize: "12px", opacity: 0.8 }}>
						<div className="col-md-4 no-padding">Product Name</div>
						<div className="col-md-4 no-padding">Due Date (From):</div>
						<div className="col-md-4 no-padding">Due Date (To):</div>
					</div>
				</div>
			</div>
		);
	}

	makeTopActionbar() {
		return (
			<div className="topActionBarStyle" style={{ padding: "15px 15px 15px 30px", border: "1px solid #dfdfdf" }}>
				<div className="row">
					<div className="col-md-8">
						<div className="row TopLables" style={{ fontSize: "12px", opacity: 0.8 }}>
							<div className="col-md-3 no-padding">Search BY BZID:</div>
							<div className="col-md-3 no-padding">Status:</div>
							<div className="col-md-5">
								<div className="row">
									<div className="col-md-6 no-padding">From Date(Created):</div>
									<div className="col-md-6 no-padding">To Date(Created):</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-3 top-filter nopadding">
								<div className="row">
									<div className="col-md-9" style={{ paddingRight: "0px" }}>
										<input id={"credit_transaction_input"} type="text" placeholder="Please enter BZID" value={this.state.BZID} onChange={this.setBzId} className="filter-text form-control" />
									</div>
									<div className="col-md-2 no-padding">
										<i className="far fa-times-circle inline" onClick={this.clearBzId} />
									</div>
								</div>
							</div>
							<div className="col-md-3 top-filter nopadding">
								<JtMultiSelect style={{ background: "inherit" }} options={this.state.statuses} applyMultiSelected={this.applyMultiSelected} title="Status" />
							</div>
							<div className="col-md-5">
								<div className="row">
									<div className="col-md-6 top-filter nopadding">
										<input type="date" onChange={this.setFromDate} className="filter-text form-control" value={this.state.fromDateCreated} />
									</div>
									<div className="col-md-6 top-filter nopadding">
										<input type="date" className="filter-text form-control" onChange={this.setToDate} value={this.state.toDateCreated} />
									</div>
								</div>
							</div>
							<div className="col-md-1 top-filter nopadding">{this.showMore()}</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="row">
							<div className="col-md-3" style={{ lineHeight: "40px" }}>
								<button id="myBtn" className="btn btn-default" onClick={this.handleSearchLocal}>
									Search
								</button>
							</div>
							<div className="col-md-6 littleMorePadding" style={{ lineHeight: "40px" }}>
								<button className="btn btn-default" style={{ color: "green" }} onClick={this.handleDownloadDump}>
									Download Dump
								</button>
							</div>
							<div className="col-md-3" style={{ lineHeight: "40px" }}>
								<button className="btn btn-default" style={{ color: "red" }} onClick={this.handleClear.bind(this)}>
									Clear Filters
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/creditTransactions/components/CreditTransactionsHeader.js